import decode from 'jwt-decode'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    jwtToken: sessionStorage.getItem('jwtToken'),
    updatedAt: Number(sessionStorage.getItem('jwtTokenUpdatedAt')),
    requestedAt: Number(sessionStorage.getItem('requestedAt'))
  },
  mutations: {
    login  (state, jwtToken) {
      state.jwtToken = jwtToken
      state.updatedAt = (new Date()).getTime()
      state.requestedAt = (new Date()).getTime()
      sessionStorage.setItem('jwtToken', jwtToken)
      sessionStorage.setItem('jwtTokenUpdatedAt', state.updatedAt)
      sessionStorage.setItem('requestedAt', state.requestedAt)
    },
    logout (state) {
      state.jwtToken = null
      state.updatedAt = null
    },
    requested (state) {
      state.requestedAt = (new Date()).getTime()
      // console.log(state.requestedAt)
      sessionStorage.setItem('requestedAt', state.requestedAt)
    },
    refresh (state) {
      let now = +(new Date())
      // console.log('AuthStore::refresh action', {now})
      state.updatedAt = now
      sessionStorage.setItem('jwtTokenUpdatedAt', now)
    }
  },
  actions: {
    login ({ commit }, jwtToken) {
      commit('login', jwtToken)
      commit('requested')
    },
    logout ({ commit }) {
      axios('/web/auth/logout/').then(() => {
        console.log('用户退出登录') // eslint-disable-line no-console
      }).catch((error) => {
        console.error(error) // eslint-disable-line no-console
      }).then(() => {
        commit('SiteStore/reset', {}, { root: true })
        commit('UserStore/reset', {}, { root: true })
        commit('logout')
        sessionStorage.clear()
      })
    },
    // 最后一次操作时间戳
    requested ({commit}) {
      commit('requested')
    },
    // 更新口令牌
    refreshToken ({commit}) {
      axios('/web/auth/refresh/').then((response) => {
        commit('requested')
        commit('login', response.data.token)
      }).catch((error) => {
        console.error(error) // eslint-disable-line no-console
      }).then(() => {
        // console.log('AuthStore::refreshToken final')
        commit('refresh')
      })
    }
  },
  getters: {
    token: (state) => state.jwtToken,
    requestedAt: (state) => state.requestedAt,
    updatedAt: (state) => state.updatedAt,
    expirationDate: (state) => {
      if (!state.jwtToken) {
        return null
      }
      const token = decode(state.jwtToken)
      if (!token.exp) { return null }
      const date = new Date(0)
      date.setUTCSeconds(token.exp)
      return date
    },
    tokenValid: (state, getters) => {
      const expirationDate = getters.expirationDate
      if (expirationDate === null) { return false }
      return expirationDate > new Date()
    },
    valid: (state) => {
      // 如果jwt token没有的话表示未登录
      if (!state.jwtToken || state.jwtToken === '' || !state.updatedAt) { return false }
      let start = state.updatedAt
      let now = new Date().getTime()
      let diff = now - start
      // 更新时间超过30分钟就超期
      if (diff > 60 * 60 * 1000) { return false }
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/AuthStore.js